export default __webpack_public_path__ + "static/media/cov.6f206087.png";